import styled from "styled-components";
import { FlexContainer,PrimaryButton } from "./styled";
import { useUserContext } from "../context/UserContext";
import { useState,useEffect } from "react";
const AirdropModalContent = ({ airdrop,closeModal,navigate }) => {
    const {fetchUser} = useUserContext();
    const [airdropImage, setAirdropImage] = useState(null);
    const [airdropTitle, setAirdropTitle] = useState(null);
    const [airdropDescription, setAirdropDescription] = useState(null);
    // if(!airdrop) return null;

    const onDone = async () => {
        if(airdrop.type === "CardPack" || airdrop.type === "Enhancer"){           
            await fetchUser();
            closeModal();
            navigate("/inventory");
            return
        }
        await fetchUser();
        closeModal();     
    }
    const handleAirdropData = () =>{
        if(airdrop.type === "CardPack"){
            setAirdropImage(airdrop.pack.imageUri);
            setAirdropTitle(airdrop.pack.name);
            setAirdropDescription(airdrop.pack.description);
            return
        }
        if(airdrop.type === "Enhancer"){
            setAirdropImage(airdrop.enhancer.imageUri);
            setAirdropTitle(airdrop.enhancer.name);
            setAirdropDescription(airdrop.enhancer.description);
            return
        }
        setAirdropImage(airdrop.token.imageUri);
        setAirdropTitle(airdrop.token.name);
        setAirdropDescription(`You have received ${airdrop.amount} ${airdrop.token.name} token`);
    }
    useEffect(() => {
        handleAirdropData();
    }, [airdrop]);


    return (
        <FlexContainer style={{padding:"8px 18px"}} gap="8px" flexdirection="column">
            <AirdropImage src={airdropImage} />
            <AirdropTitle>{airdropTitle}</AirdropTitle>
            <AirdropDescription>{airdropDescription}</AirdropDescription>
            <PrimaryButton style={{width:"50%",marginBottom:"24px"}} onClick={onDone}>{airdrop.type === "CardPack" || airdrop.type ==="Enhancer" ? "Inventory" : "Done"}</PrimaryButton>
        </FlexContainer>
    );
};

const AirdropImage = styled.img`
    width: 100px;
    /* height: 100px; */
    margin: 0 auto;
`;
const AirdropTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin: 8px 0;
`;
const AirdropDescription = styled.p`
    font-size: 14px;
    text-align: center;
    margin: 8px 0;
`;

export default AirdropModalContent;